import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles, Box, Typography } from "@material-ui/core";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";

import LoaderView from "../../../components/LoaderView";

import { getEmployeeWeekData } from "utils/report";
import { getWeekNumber } from "services";
import { isEmptyObject } from "utils";
import {
  getTranslatedActivityGroupFromCamelCase,
  getTranslatedJobFamilyFromCamelCase,
} from "../components/utils";

const useStyles = makeStyles({});

const EmployeesActivities = (props) => {
  const { employeesUnderManager, employeesUnderManagerLoading } = props,
    { t } = useTranslation(),
    classes = useStyles();
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [workerJobFamilyHours, setWorkerJobFamilyHours] = useState(null);
  const [workerActivityGroupHours, setWorkerActivityGroupHours] =
    useState(null);
  const [workerHoursLoading, setWorkerHoursLoading] = useState(true);
  const [isJobFamilyDataAvailable, setIsJobFamilyDataAvailable] =
    useState(false);
  const [isActivityGroupDataAvailable, setIsActivityGroupDataAvailable] =
    useState(false);
  const [mouseYPositionWithStackedBar, setMouseYPositionWithStackedBar] =
    useState(1);

  useEffect(() => {
    setSelectedWorker(null);
  }, [employeesUnderManager]);

  useEffect(() => {
    setWorkerHoursLoading(true);
    const weekNumber = getWeekNumber(new Date()); // "202141";
    // const selectedWorker = {};
    // selectedWorker.workerId = "9100182";
    if (!isEmptyObject(selectedWorker)) {
      getEmployeeWeekData(selectedWorker.workerId, weekNumber).then(
        (querySnapshotData) => {
          const document = [];
          if (!isEmptyObject(querySnapshotData)) {
            if (querySnapshotData.timesheetStatus !== "deleted") {
              let jobFamilyTotals =
                querySnapshotData.weekTotalHours.jobFamilyTotals;

              let activityGroupTotals = {};

              for (let jobFamily in jobFamilyTotals) {
                const jobFamilyHours = jobFamilyTotals[jobFamily];
                activityGroupTotals = {};

                for (let activityGroup in jobFamilyHours) {
                  if (jobFamilyHours[activityGroup] !== 0) {
                    const translatedActivityGroup =
                      getTranslatedActivityGroupFromCamelCase(
                        activityGroup,
                        i18n.language
                      );
                    activityGroupTotals[translatedActivityGroup] =
                      jobFamilyHours[activityGroup].toFixed(2);
                  }
                }

                document.push({
                  jobFamily: getTranslatedJobFamilyFromCamelCase(
                    jobFamily,
                    i18n.language
                  ),
                  ...activityGroupTotals,
                });
              }

              setWorkerJobFamilyHours(document);
              setIsJobFamilyDataAvailable(true);

              activityGroupTotals = {};

              activityGroupTotals =
                querySnapshotData.weekTotalHours.activityGroupTotals;

              if (!isEmptyObject(activityGroupTotals)) {
                let totalHours = 0;

                for (let activityGroup in activityGroupTotals) {
                  if (activityGroupTotals[activityGroup] != 0) {
                    totalHours += activityGroupTotals[activityGroup];
                    const translatedActivityGroup =
                      getTranslatedActivityGroupFromCamelCase(
                        activityGroup,
                        i18n.language
                      );
                    activityGroupTotals[translatedActivityGroup] =
                      activityGroupTotals[activityGroup];
                  }
                }
                activityGroupTotals.totalHours = totalHours.toFixed(2);
              }

              setWorkerActivityGroupHours([activityGroupTotals]);
              setIsActivityGroupDataAvailable(true);
              if (querySnapshotData.weekTotalHours.activityHours === 0) {
                setIsActivityGroupDataAvailable(false);
                setIsJobFamilyDataAvailable(false);
              }
            } else {
              setIsJobFamilyDataAvailable(false);
              setIsActivityGroupDataAvailable(false);
              setWorkerJobFamilyHours([]);
              setWorkerActivityGroupHours([{}]);
            }
          } else {
            setIsJobFamilyDataAvailable(false);
            setIsActivityGroupDataAvailable(false);
            setWorkerJobFamilyHours([]);
            setWorkerActivityGroupHours([{}]);
          }
        }
      );
    } else {
      setIsJobFamilyDataAvailable(false);
      setIsActivityGroupDataAvailable(false);
      setWorkerJobFamilyHours([]);
      setWorkerActivityGroupHours([{}]);
    }
    setWorkerHoursLoading(false);
  }, [selectedWorker]);

  return (
    <>
      <LoaderView loading={employeesUnderManagerLoading}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={4}
        >
          <Grid item xs="auto">
            {/* <LoaderView loading={employeesUnderManagerLoading}> */}
            <Autocomplete
              id="combo-box-demo"
              options={employeesUnderManager}
              getOptionLabel={(option) =>
                option.workerName + " (" + option.workerId + ") "
              }
              value={selectedWorker}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  setSelectedWorker(newValue);
                } else {
                  setSelectedWorker(null);
                }
              }}
              style={{ width: 200 }}
              renderInput={(params) => {
                if (selectedWorker === null) {
                  return <TextField {...params} label="Select Employee" />;
                } else {
                  return <TextField {...params} label="Employee" />;
                }
              }}
            />
            {/* </LoaderView> */}
          </Grid>
          {/* <Grid item> */}
          {/* <LoaderView loading={workerHoursLoading}> */}
          {isActivityGroupDataAvailable ? (
            // <ResponsiveContainer width="100%" height={"100%"}>
            <>
              {/* <Grid container spacing={3} direction="row" alignItems="center"> */}
              <Grid item xs="auto">
                <Typography variant="h6">Total</Typography>
              </Grid>
              <Grid item xs="auto">
                <BarChart
                  width={500}
                  height={50}
                  data={workerActivityGroupHours}
                  layout="vertical"
                  margin={{ left: 10 }}
                >
                  <XAxis type="number" hide axisLine={false} />
                  <YAxis
                    dataKey="totalHours"
                    orientation="left"
                    type="category"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: "#1b75bc", fontSize: 25 }}
                  />
                  <Tooltip
                    wrapperStyle={{ zIndex: 1 }}
                    labelFormatter={function (value) {
                      return ``;
                    }}
                  />
                  {/* <Legend /> */}
                  <Bar
                    dataKey={getTranslatedActivityGroupFromCamelCase(
                      "buildingMoves",
                      i18n.language
                    )}
                    stackId="b"
                    fill="#3C5772"
                  />
                  <Bar
                    dataKey={getTranslatedActivityGroupFromCamelCase(
                      "nonTransactional",
                      i18n.language
                    )}
                    stackId="b"
                    fill="#00A88E"
                  />
                  <Bar
                    dataKey={getTranslatedActivityGroupFromCamelCase(
                      "transactional",
                      i18n.language
                    )}
                    stackId="b"
                    fill="#1B75BC"
                  />
                  <Bar
                    dataKey={getTranslatedActivityGroupFromCamelCase(
                      "project",
                      i18n.language
                    )}
                    stackId="b"
                    fill="#6DCFF6"
                  />
                </BarChart>
              </Grid>
              {/* </Grid> */}
            </>
          ) : // </ResponsiveContainer>
          null}
          {/* </LoaderView> */}
          {/* </Grid> */}
        </Grid>
        <LoaderView loading={workerHoursLoading}>
          {isJobFamilyDataAvailable ? (
            // <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={730}
              height={50 * workerJobFamilyHours.length}
              data={workerJobFamilyHours}
              layout="vertical"
              margin={{ left: 75, top: 10 }}
              onMouseMove={(event) => {
                if (event.chartY) {
                  setMouseYPositionWithStackedBar(event.chartY);
                }
              }}
            >
              <XAxis type="number" hide axisLine={false} />
              <YAxis
                dataKey="jobFamily"
                orientation="left"
                type="category"
                axisLine={false}
                tickLine={false}
              />
              <Tooltip
                position={{ y: mouseYPositionWithStackedBar - 100 }}
                labelFormatter={function (value) {
                  return ``;
                }}
              />
              {/* <Legend /> */}
              <Bar
                dataKey={getTranslatedActivityGroupFromCamelCase(
                  "buildingMoves",
                  i18n.language
                )}
                stackId="a"
                fill="#3C5772"
              />
              <Bar
                dataKey={getTranslatedActivityGroupFromCamelCase(
                  "nonTransactional",
                  i18n.language
                )}
                stackId="a"
                fill="#00A88E"
              />
              <Bar
                dataKey={getTranslatedActivityGroupFromCamelCase(
                  "transactional",
                  i18n.language
                )}
                stackId="a"
                fill="#1B75BC"
              />
              <Bar
                dataKey={getTranslatedActivityGroupFromCamelCase(
                  "project",
                  i18n.language
                )}
                stackId="a"
                fill="#6DCFF6"
              />
            </BarChart>
          ) : (
            // </ResponsiveContainer>
            <>
              <Box style={{ marginTop: "30px" }} className={classes.full}>
                <Alert severity="info">{t("pgHome.errNoReportData2")}</Alert>
              </Box>
            </>
          )}
        </LoaderView>
      </LoaderView>
    </>
  );
};

export default EmployeesActivities;
